<template>
  <b-form-group
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${(validate.required === true || (typeof validate === 'string' && validate.search('required') !== -1) ? 'is-required' : '')}`"
  >
    <ValidationProvider
      v-slot="validationContext"
      ref="inputValidation"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <b-form-checkbox
        v-model="_value"
        switch
        :name="name"
        :placeholder="placeholder"
        :state="getValidationState(validationContext)"
        @change="onchange"
      >
     <span class="font-weight-normal">{{ innerLabel }}</span>
      </b-form-checkbox>
      <b-form-invalid-feedback
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputCheckboxComponent',
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      innerLabel: {
        type: String,
        required: false,
        default: ''
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      onchange: {
        type: Function,
        required: false,
        default: () => {}
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      value: {
        type: Boolean,
        required: false,
        default: false
      },
      validationMode: {
        type: String,
        required: false,
        default: 'passive'
      }
    },
    computed: {
      _value: {
        get () {
          // setTimeout(() => {
          //   this.$refs['inputValidation'].validate()
          // }, 300)
          return this.value
        },
        set (value) {
          this.$emit('update:value', value)
          this.$emit('input', value)
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>